import script from "./metric.vue?vue&type=script&lang=ts&setup=true"
export * from "./metric.vue?vue&type=script&lang=ts&setup=true"

import "./metric.vue?vue&type=style&index=0&id=6c991e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c991e4b"]])

export default __exports__